var _rect, _rect2, _rect3, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMobileMoreRouteIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 17,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 6,
  x: 1,
  y: 1,
  stroke: "#7E8A93",
  strokeWidth: 1.5,
  rx: 1
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 6,
  x: 1,
  y: 10,
  stroke: "#7E8A93",
  strokeWidth: 1.5,
  rx: 1
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 6,
  x: 10,
  y: 1,
  stroke: "#7E8A93",
  strokeWidth: 1.5,
  rx: 1
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 6,
  x: 10,
  y: 10,
  stroke: "#7E8A93",
  strokeWidth: 1.5,
  rx: 1
})));
export default SvgMobileMoreRouteIcon;